import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { Icon, List } from 'semantic-ui-react';
import {
  DeleteConfirmation,
  Analytics,
  GlobalNotifications,
  Intent
} from '../../Modules';
import documentStyles from '../Document.scss';
import Share from './Share';
import Actions from '../Sections/Actions/Actions';

export default class EstimateActions extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    node: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    windowDimensions: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      deleteModalOpen: false
    };
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.deleteEstimate = this.deleteEstimate.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
    this.print = this.print.bind(this);
  }

  deleteEstimate() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to delete estimate',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully deleted estimate',
        intent: Intent.SUCCESS
      });
      this.props.router.push('/');
      Analytics.trackEvent('deleted-estimate');
    };

    const mutation = graphql`
      mutation ActionsComponent_deleteEstimateMutation(
        $input: DeleteEstimateInput!
      ) {
        deleteEstimate(input: $input) {
          deletedEstimateId
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: { input: { id: this.props.node.id } },
      onCompleted,
      onError
    });
  }

  openDeleteModal() {
    this.setState({ deleteModalOpen: true });
  }

  closeDeleteModal() {
    this.selectItem();
    this.setState({ deleteModalOpen: false });
  }

  selectItem(callback) {
    if (this.props.onClose) this.props.onClose();
    if (callback) callback();
  }

  downloadPdf() {
    window.location = `/estimates/${this.props.node.id}.pdf`;
  }

  print() {
    window.location = `/estimates/${this.props.node.id}.pdf?disposition=inline`;
  }

  render() {
    return (
      <div>
        <DeleteConfirmation
          delete={this.deleteEstimate}
          id={this.props.node.id}
          open={this.state.deleteModalOpen}
          onClose={this.closeDeleteModal}
        />
        <Actions
          windowDimensions={this.props.windowDimensions}
          onClose={this.props.onClose}
        >
          <List>
            {this.props.params.action === 'edit' &&
              this.props.node.can_edit &&
              <List.Item
                onClick={() => this.props.router.replace(`/docs/e/${this.props.node.id}`)}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='eye' /> &nbsp; Preview
              </List.Item>}
            {this.props.params.action !== 'edit' &&
              this.props.node.can_edit &&
              <List.Item
                onClick={() => this.props.router.replace(`/docs/e/${this.props.node.id}/edit`)}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='pencil' /> &nbsp; Edit
              </List.Item>}
            <Share
              document={this.props.node}
              trigger={
                <List.Item className={documentStyles.actionMenuItem}>
                  <Icon name='share' /> &nbsp; Share
                </List.Item>
              }
              relay={this.props.relay}
              onClose={this.props.onClose}
            />
            <List.Item
              onClick={this.print}
              className={documentStyles.actionMenuItem}
            >
              <Icon name='print' /> &nbsp; Print
            </List.Item>
            <List.Item
              onClick={this.downloadPdf}
              className={documentStyles.actionMenuItem}
            >
              <Icon name='download' /> &nbsp; Download PDF
            </List.Item>
            {this.props.node.can_edit &&
              <List.Item
                onClick={this.openDeleteModal}
                className={documentStyles.actionMenuItem}
              >
                <Icon name='trash alternate' /> &nbsp; Delete Estimate
              </List.Item>}
          </List>
        </Actions>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/Actions.js